import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "currentColor",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M75 5V0H65v5H35V0H25v5H0v95h100V5zm15 85H10V40h80zM10 30V15h15v5h10v-5h30v5h10v-5h15v15z" }, null, -1),
    _createElementVNode("path", { d: "M20 70h10v10H20zM45 70h10v10H45zM70 70h10v10H70zM20 50h10v10H20zM45 50h10v10H45zM70 50h10v10H70z" }, null, -1)
  ])))
}
export default { render: render }